import script from "./MassActions.vue?vue&type=script&setup=true&lang=js"
export * from "./MassActions.vue?vue&type=script&setup=true&lang=js"

import "./MassActions.vue?vue&type=style&index=0&id=78fc8b77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fc8b77"]])

export default __exports__